import { Injectable, inject, Type  } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CargosI } from '../interfaces/list-cargo.interface';



@Injectable({providedIn: 'root'})
export class DialogService {

  private dialog = inject(MatDialog);

  openAddDialog<T>(component: Type<T>, config?: MatDialogConfig) {
    const defaultConfig: MatDialogConfig = {
      width: '700px',
      height: 'auto',
      disableClose: true,
      panelClass: ['scale-up-center'],
      ...config,
    };
    return this.dialog.open(component, defaultConfig).afterClosed();
  }

  openEditDialog<T>(data: any, component: Type<T>, config?: MatDialogConfig) {
    const defaultConfig: MatDialogConfig = {
      width: '700px',
      height: 'auto',
      disableClose: true,
      panelClass: ['scale-up-center'],
      data: data,
      ...config,
    };
    return this.dialog.open(component, defaultConfig).afterClosed();
  }

  openSelectDialog<T>(data: any, component: Type<T>, config?: MatDialogConfig) {
    const defaultConfig: MatDialogConfig = {
      width: '700px',
      height: 'auto',
      disableClose: true,
      panelClass: ['scale-up-center'],
      data: data,
      ...config,
    };
    return this.dialog.open(component, defaultConfig).afterClosed();
  }

  openViewDialog<T>(data: any, component: Type<T>, config?: MatDialogConfig) {
    const defaultConfig: MatDialogConfig = {
      width: '700px',
      height: 'auto',
      disableClose: true,
      panelClass: ['scale-up-center'],
      data: data,
      ...config,
    };
    return this.dialog.open(component, defaultConfig).afterClosed();
  }


}
